/* eslint no-console: ["error", { allow: ["error"] }] */
import Hlsjs from 'hls.js';
import videojs from 'video.js';
import HlsUtils from './_hls-utils';
import 'videojs-contrib-media-sources';

videojs.registerComponent('Hlsjs', Hlsjs);
const Html5 = videojs.getComponent('Html5');

Html5.registerSourceHandler({
  canHandleSource: (source) => {
    if (
      source.hasOwnProperty('data-disable-hlsjs') &&
      source['data-disable-hlsjs'] !== 'false' &&
      source['data-disable-hlsjs'] !== false &&
      source['data-disable-hlsjs'] !== '0' &&
      source['data-disable-hlsjs'] !== 0
    ) {
      return '';
    }
    if (!Hlsjs.isSupported()) {
      return '';
    }
    return HlsUtils.isHlsSource(source);
  },

  canPlayType: (type) => {
    if (!Hlsjs.isSupported()) {
      return '';
    }
    return HlsUtils.isHlsType(type);
  },

  handleSource: (source, tech) => {
    return new Html5HlsjsHandler(source, tech);
  }
}, 0 /* source handler position */);

class Html5HlsjsHandler {
  constructor(source, tech) {
    this.tech_ = tech;
    this.el_ = this.tech_.el();
    this.duration_ = null;
    this.hls_ = new Hlsjs(this.tech_.options_.hlsjs);

    this.recoverDecodingErrorDate_ = null;
    this.recoverAudioCodecErrorDate_ = null;
    this.recoverNetworkErrorAttemptsRemaining_ = 3;

    // update live status on level load
    this.hls_.on(Hlsjs.Events.LEVEL_LOADED, (event, data) => {
      this.duration_ = data.details.live ? Infinity : data.details.totalduration;
    });

    // try to recover on fatal errors
    this.hls_.on(Hlsjs.Events.ERROR, this.onHlsjsError.bind(this));

    // attach hlsjs to videotag
    this.hls_.attachMedia(this.el_);
    this.hls_.loadSource(source.src);
  }

  dispose() {
    this.hls_.destroy();
  }

  /**
   * returns the duration of the stream, or Infinity if live video
   * @returns {Infinity|number}
   */
  duration() {
    return this.duration_ || this.el_.duration || 0;
  }

  onHlsjsError(event, data) {
    if (data.fatal) {
      switch (data.type) {
        case Hlsjs.ErrorTypes.NETWORK_ERROR:
          if (this.recoverNetworkErrorAttemptsRemaining_ > 0) {
            this.recoverNetworkErrorAttemptsRemaining_ -= 1;
            if (
              data.details === Hlsjs.ErrorDetails.MANIFEST_LOAD_ERROR ||
              data.details === Hlsjs.ErrorDetails.MANIFEST_LOAD_TIMEOUT ||
              data.details === Hlsjs.ErrorDetails.MANIFEST_PARSING_ERROR
            ) {
              this.hls_.loadSource(this.hls_.url);
            } else {
              this.hls_.startLoad();
            }
          } else {
            this.error(MediaError.MEDIA_ERR_NETWORK, event, data);
          }
          break;

        case Hlsjs.ErrorTypes.MEDIA_ERROR:
          const now = Date.now();
          if (!this.recoverDecodingErrorDate_ || (now - this.recoverDecodingErrorDate_) > 2000) {
            this.recoverDecodingErrorDate_ = now;
            this.hls_.recoverMediaError();
          } else if (!this.recoverAudioCodecErrorDate_ || (now - this.recoverAudioCodecErrorDate_) > 2000) {
            this.recoverAudioCodecErrorDate_ = now;
            this.hls_.swapAudioCodec();
            this.hls_.recoverMediaError();
          } else {
            this.error(MediaError.MEDIA_ERR_DECODE, event, data);
          }
          break;

        default:
        case Hlsjs.ErrorTypes.MUX_ERROR:
        case Hlsjs.ErrorTypes.OTHER_ERROR:
          this.error(MediaError.MEDIA_ERR_DECODE, event, data);
          break;
      }
    }
  }

  error(err, event, data) {
    console.error(`html5-hlsjs-handler: Hls.js error event ${event}`, data);
    let player = videojs.players[this.tech_.options_.playerId];
    player.error(err);
  }
}


// Настройки по-умолчанию
videojs.options.html5.hlsjs = videojs.options.html5.hlsjs || {};



// WEBPACK FOOTER //
// ./src/source-handlers/html5-hlsjs-handler.js